import { types } from "../../types";

const initialState = {
    pagination: {
        data: [],
        per_page: 5,
    },
    active: null,
    openForm: false,
    openContract: false,
    nextNumberEmployee: null,
    list: [],
    groups: [],
    subjects: [],
    subjectActive: null,
    documents: [],
    openModalWeekPayments: false,
    openModalDocumentsReport: false,
};

export const teacherReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.teacherNextNumberEmployee:
            return {
                ...state,
                nextNumberEmployee: action.payload,
            };
        case types.teacherShow:
            return {
                ...state,
                pagination: action.payload.pagination,
            };
        case types.teacherList:
            return {
                ...state,
                list: action.payload,
            };
        case types.teacherOpenModal:
            return {
                ...state,
                openForm: true,
            };
        case types.teacherCloseModal:
            return {
                ...state,
                openForm: false,
                active: null,
            };
        case types.teacherOpenContract:
            return {
                ...state,
                openContract: true,
            };
        case types.teacherCloseContract:
            return {
                ...state,
                openContract: false,
            };

        case types.teacherSetActive:
            return {
                ...state,
                active: action.payload,
            };
        case types.teacherUnsetActive:
            return {
                ...state,
                active: null,
            };
        case types.teacherGroups:
            return {
                ...state,
                groups: action.payload,
            };
        case types.teacherSubjects:
            return {
                ...state,
                subjects: action.payload,
            };
        case types.teacherSubjectActive:
            return {
                ...state,
                subjectActive: action.payload,
            };
        case types.teacherDocuments:
            return {
                ...state,
                documents: action.payload,
            };
        case types.teacherOpenModalWeekPayments:
            return {
                ...state,
                openModalWeekPayments: true,
            };
        case types.teacherCloseModalWeekPayments:
            return {
                ...state,
                openModalWeekPayments: false,
            };
        case types.teacherOpenModalDocumentsReport:
            return {
                ...state,
                openModalDocumentsReport: true,
            };
        case types.teacherCloseModalDocumentsReport:
            return {
                ...state,
                openModalDocumentsReport: false,
            };
        default:
            return state;
    }
};
